<template>
    <div :class="headerData.scrollMenuMobileJudge ? 'header-main active' : 'header-main'">
        <div class="logo commonCenter divFlex">
            <div class="logo-left">
                <img :src="headerData.logoUrl ? headerData.logoUrl : ''" alt="">
            </div>
            <div class="logo-right" v-if="headerData.platform === 'PC'">
                <div v-if="headerData.searchVisible" class="middle inputStyle">
                    <el-input v-model="headerData.inputVal" style="width: 320px;" clearable
                        placeholder="SEARCH HERE YOU WANT">
                        <template #append>
                            <svg @click="searchGoods" t="1741144334841" class="icon" viewBox="0 0 1024 1024"
                                version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="30090" width="16" height="16">
                                <path
                                    d="M881 562H81c-27.6 0-50-22.4-50-50s22.4-50 50-50h800c27.6 0 50 22.4 50 50s-22.4 50-50 50z"
                                    p-id="30091" fill="#ffffff"></path>
                                <path
                                    d="M907.6 540.7L695.5 328.6c-19.5-19.5-19.5-51.2 0-70.7s51.2-19.5 70.7 0L978.4 470c19.5 19.5 19.5 51.2 0 70.7-19.6 19.6-51.2 19.6-70.8 0z"
                                    p-id="30092" fill="#ffffff"></path>
                                <path
                                    d="M695.5 695.4l212.1-212.1c19.5-19.5 51.2-19.5 70.7 0s19.5 51.2 0 70.7L766.2 766.1c-19.5 19.5-51.2 19.5-70.7 0s-19.5-51.2 0-70.7z"
                                    p-id="30093" fill="#ffffff"></path>
                            </svg>
                        </template>
                    </el-input>
                </div>
                <el-button icon="Search" type="primary" @click="headerData.searchVisible = !headerData.searchVisible" />
                <el-button icon="ShoppingCart" type="primary" @click="shoppingCartClick" />
                <el-tooltip placement="bottom" effect="light">
                    <template #content>
                        <ul class="moreInfo">
                            <li v-if="headerData.token" @click="loginOut">Welcome ? <span>Sign Out</span></li>
                            <li v-else @click="router.push('/register')">New Customer ? <span>Sign Up</span></li>
                            <li @click="profileJump">My Profile</li>
                            <li @click="router.push('/terms')">Terms & Conditions</li>
                            <li @click="router.push('/privacy')">Pivacy Policy</li>
                        </ul>
                    </template>
                    <el-button class="login" icon="Operation" type="primary">{{ headerData.token ? 'Logout' :
        'Sign-In/Sign-Up'
                        }}</el-button>
                </el-tooltip>
            </div>
            <div class="logo-right" v-else>
                <svg @click="shoppingCartClick" t="1742179775896" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="2680" width="30" height="30">
                    <path
                        d="M352.972955 831.860239c-35.434907 0-63.989249 28.554342-63.989249 63.989249 0 35.434907 28.554342 63.989249 63.989249 63.989249s63.989249-28.554342 63.989249-63.989249C416.962204 860.414581 388.407862 831.860239 352.972955 831.860239L352.972955 831.860239z"
                        fill="#575B66" p-id="2681"></path>
                    <path
                        d="M801.069713 831.860239c-35.434907 0-63.989249 28.554342-63.989249 63.989249 0 35.434907 28.554342 63.989249 63.989249 63.989249s63.989249-28.554342 63.989249-63.989249C865.058962 860.414581 836.332605 831.860239 801.069713 831.860239L801.069713 831.860239z"
                        fill="#575B66" p-id="2682"></path>
                    <path
                        d="M937.304888 188.527465C920.963548 169.949941 898.429699 159.973123 874.003696 159.973123L232.907106 159.973123l-2.236183-13.073072c-5.676466-46.615824-46.615824-82.910801-93.231648-82.910801L97.015958 63.989249c-17.717453 0-31.994625 14.277171-31.994625 31.994625s14.277171 31.994625 31.994625 31.994625l40.251302 0c13.933143 0 28.210314 12.729044 29.930455 28.210314l30.96254 178.550647 54.356459 382.043339c5.676466 46.615824 46.099782 83.082815 92.371577 83.082815l520.17067 0c17.717453 0 31.994625-14.277171 31.994625-31.994625s-14.277171-31.994625-31.994625-31.994625L344.716278 735.876365c-13.589115 0-27.006215-12.55703-28.898371-27.522258l-5.332437-37.327062 507.61364-31.306568c46.099782 0 86.695112-36.466991 92.027549-81.362674L960.870821 270.062154C964.483118 239.271628 956.054426 209.513187 937.304888 188.527465z"
                        fill="#575B66" p-id="2683"></path>
                </svg>
                <svg @click="headerData.menuMobileVisible = true;" t="1742179901123" class="icon"
                    viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5481" width="28"
                    height="28">
                    <path
                        d="M906.19904 116.38784H115.92704c-34.31424 0-62.14656 27.83744-62.14656 62.17216v0.29696c0 34.33984 27.83232 62.17216 62.14656 62.17216h790.272c34.30912 0 62.15168-27.83744 62.15168-62.17216v-0.29696c0-34.33472-27.84256-62.17216-62.15168-62.17216z m-0.31744 331.05408H116.2496c-34.5088 0-62.46912 27.98592-62.46912 62.47424v0.49152c0 34.48832 27.9552 62.46912 62.46912 62.46912H905.8816c34.5088 0 62.46912-27.9808 62.46912-62.46912v-0.49152c0-34.48832-27.96032-62.47424-62.46912-62.47424z m0.31744 331.84768H115.92704c-34.31424 0-62.14656 27.84256-62.14656 62.17728v0.29696c0 34.33984 27.83232 62.17728 62.14656 62.17728h790.272c34.30912 0 62.15168-27.83744 62.15168-62.17728v-0.29696c0-34.33472-27.84256-62.17728-62.15168-62.17728z"
                        p-id="5482"></path>
                </svg>
            </div>
        </div>
        <div :class="headerData.scrollMenuJudge ? 'menu active' : 'menu'" v-if="headerData.platform === 'PC'">
            <ul class="commonCenter divFlex">
                <li @click="goHome">HOME</li>
                <li @click="router.push('/about')">ABOUT</li>
                <li v-for="item in headerData.menuList" :key="item.id" @click="menuClick(item)">{{ item.name }}</li>
                <li @click="router.push('/contact')">CONTACT</li>
            </ul>
        </div>

        <!-- dialog -->
        <el-drawer v-model="headerData.menuMobileVisible" title="Menu" class="mobileMenu" direction="ltr" size="70%">
            <div class="inputStyle">
                <el-input v-model="headerData.inputVal" style="width: 100%;" clearable
                    placeholder="SEARCH HERE YOU WANT">
                    <template #append>
                        <svg @click="() => {
        searchGoods();
        headerData.menuMobileVisible = false;
    }" t="1741144334841" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
                            p-id="30090" width="16" height="16">
                            <path
                                d="M881 562H81c-27.6 0-50-22.4-50-50s22.4-50 50-50h800c27.6 0 50 22.4 50 50s-22.4 50-50 50z"
                                p-id="30091" fill="#ffffff"></path>
                            <path
                                d="M907.6 540.7L695.5 328.6c-19.5-19.5-19.5-51.2 0-70.7s51.2-19.5 70.7 0L978.4 470c19.5 19.5 19.5 51.2 0 70.7-19.6 19.6-51.2 19.6-70.8 0z"
                                p-id="30092" fill="#ffffff"></path>
                            <path
                                d="M695.5 695.4l212.1-212.1c19.5-19.5 51.2-19.5 70.7 0s19.5 51.2 0 70.7L766.2 766.1c-19.5 19.5-51.2 19.5-70.7 0s-19.5-51.2 0-70.7z"
                                p-id="30093" fill="#ffffff"></path>
                        </svg>
                    </template>
                </el-input>
            </div>
            <ul @click="headerData.menuMobileVisible = false">
                <li @click="goHome">HOME</li>
                <li @click="router.push('/about')">ABOUT</li>
                <li v-for="item in headerData.menuList" :key="item.id" @click="menuClick(item)">{{ item.name }}</li>
                <li @click="profileJump">MY PROFILE</li>
                <li @click="router.push('/contact')">CONTACT</li>
                <li @click="router.push('/privacy')">PRIVACY POLICY</li>
                <li @click="router.push('/terms')">TERMS & CONDITIONS</li>
                <li @click="router.push('/refund')">REFUND & CANCELLATION</li>
                <li @click="router.push('/shipping')">SHIPPING POLICY</li>
                <li v-if="headerData.token" @click="loginOut">WELCOME ? <span>SIGN OUT</span></li>
                <li v-else @click="router.push('/register')">NEW CUSTOMER ? <span>SIGN UP</span></li>
            </ul>
        </el-drawer>
    </div>
</template>

<script setup>
import { reactive, onMounted, onUnmounted, watch } from 'vue';
import { useRouter } from 'vue-router'
import { goHome, logOut, checkoutLogin } from "@/utils/utils"
import API from '@/utils/request'
import { useStore } from 'vuex'
import logoImageUrl from '@/assets/images/logo.png'
const store = useStore()

const router = useRouter();
const headerData = reactive({
    searchVisible: false,
    inputVal: '',
    menuList: [],
    token: '',
    scrollMenuJudge: false,
    scrollMenuMobileJudge: false,
    platform: '',
    menuMobileVisible: false,
    logoUrl: ''
})

// 获取商品列表
const getProductPage = (categoryId) => {
    let obj = store.state.indexProductList;
    API.getRequest('product/page', {
        current: 1,
        pageSize: 10,
        categoryId
    }, (res) => {
        let datas = res.data.records;
        obj[categoryId] = datas;
        store.commit('setIndexProductList', obj)
    })
}
// 获取菜单
const getMenuList = () => {
    API.getRequest('category/root', {}, (res) => {
        let datas = res.data;
        headerData.menuList = [].concat(datas);
        for (let i in datas) {
            getProductPage(datas[i].id);
        }
    })
}

// 菜单跳转
const shoppingCartClick = () => {
    checkoutLogin(() => {
        router.push('/cart');
    })
}
const profileJump = () => {
    checkoutLogin(() => {
        router.push('/profile')
    })
}
const menuClick = (item) => {
    router.push('/goods/' + item.id + '/' + item.name);
}
const searchGoods = () => {
    if (headerData.inputVal) {
        router.push('/search/' + headerData.inputVal);
        headerData.inputVal = '';
        headerData.searchVisible = false;
    }
}
// 退出登录
const loginOut = () => {
    logOut()
}

watch(
    [
        () => store.state.token,
        () => store.state.platform,
        () => store.state.websiteData
    ],

    ([newToken, newPlatform, websiteDataVal]) => {
        headerData.token = newToken;
        headerData.platform = newPlatform;
        headerData.logoUrl = websiteDataVal.HOME_LOGO;
    },
    {
        immediate: true, // 立即执行一次
        deep: true      // 深度监听
    }
)

const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (headerData.platform === 'PC') {
        if (scrollTop > 130) {
            headerData.scrollMenuJudge = true;
        } else {
            headerData.scrollMenuJudge = false;
        }
        headerData.scrollMenuMobileJudge = false;
    } else {

        if (scrollTop > 100) {
            headerData.scrollMenuMobileJudge = true;
        } else {
            headerData.scrollMenuMobileJudge = false;
        }
        headerData.scrollMenuJudge = false;
    }
}


onMounted(() => {
    getMenuList()
    headerData.token = store.state.token;
    window.addEventListener('scroll', handleScroll)  // 添加滚动监听
})

onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll)  // 移除滚动监听
})
</script>
<style lang="scss">
.header-main .logo-right .el-button span {
    font-size: 12px;
}

.header-main .logo-right {
    >svg {
        display: inline-block;
        vertical-align: middle;
        margin-left: 30px;
        cursor: pointer;

        path {
            fill: $bgColor;
        }
    }
}

.inputStyle {

    .el-input__inner {
        color: #fff;
    }

    .el-input-group__append {
        background-color: var(--el-color-primary);
        cursor: pointer;
    }

    .el-input__wrapper {
        background-color: var(--el-color-primary);

        // 添加 placeholder 样式
        input::placeholder {
            color: $color3;
        }

        // 兼容 Firefox
        input::-moz-placeholder {
            color: $color3;
        }

        // 兼容 Chrome/Safari
        input::-webkit-input-placeholder {
            color: $color3;
        }
    }
}

.mobileMenu {
    ul {
        padding: 15px 0;

        li {
            padding: 15px;
            border-bottom: #e5e5e5 1px dotted;
            cursor: pointer;

            &:hover {
                font-weight: bold;
            }

            span {
                color: #F56C6C;
            }
        }
    }

}

.moreInfo {
    width: 300px;
}

.moreInfo li {
    padding: 12px 20px;
    border-bottom: #f1f1f1 1px solid;
    cursor: pointer;
}

.moreInfo li:hover {
    background-color: lightgray;
}

.moreInfo li span {
    color: #F56C6C;
    margin-left: 10px;
}
</style>
<style scoped lang="scss">
.header-main {
    transition: all .1s linear;

    &.active {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        background-color: $color2;
        z-index: 100;
    }

    .logo {
        padding: 4px 0;

        .logo-left {
            min-height: 80px;

            img {
                display: block;
                height: 80px;
            }
        }

    }

    .menu {
        background-color: $bgColor;
        transition: all .1s linear;

        &.active {
            position: fixed;
            left: 0;
            top: 0;
            width: 100%;
            padding: 6px 0;
            z-index: 100;
        }

        ul {
            height: 40px;
            justify-content: center;

            li {
                display: inline-block;
                font-size: 13px;
                padding: 9px 15px;
                font-weight: 700;
                color: $color2;
                cursor: pointer;

                &:hover {
                    color: $color3;
                }
            }
        }
    }
}

@media screen and (max-width: 930px) {
    .header-main {
        padding: 0 15px;
    }
}
</style>